import PropTypes from 'prop-types';
import BedIcon from '../../../../../assets/images/icons/bedIcon.svg';

const Icon = ({ rateContent }) => {
  const iconSrc = !!rateContent?.mealPlanList
    ? rateContent.mealPlanList[0].iconUrl
    : BedIcon;

  return (
    <img
      src={iconSrc}
      alt={rateContent?.mealPlanList?.[0]?.name || 'accommodation only'}
    />
  );
};

Icon.propTypes = {
  rateContent: PropTypes.shape({
    mealPlanList: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string.isRequired,
        iconUrl: PropTypes.string.isRequired,
      }).isRequired
    ),
  }),
};

export default Icon;
